import React, { useEffect } from "react"
import { navigate } from "gatsby"
const PageRedirect = () => {
  useEffect(() => {
    navigate("/case-studies/aceing-sales-with-ondemand-meeting-spaces/")
  }, [])
  return <div> </div>
}
export default PageRedirect
